/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { getVariantPath } from '../../utils/get-variant-path'

import { buildCardComponentArray, innerElementMargin } from './card'

const stylePath = (field) =>
  getVariantPath({
    atomicType: 'modules',
    componentId: 'featuredCards',
    variantName: 'steps',
    field,
  })

const CardWithStep = (props) => {
  const { columnNumber } = props
  const components = buildCardComponentArray(props)
  const gridRowContainerStyling = `1 / span ${components.length}`

  return (
    <div sx={{ variant: stylePath('card') }}>
      <div
        sx={{
          gridColumn: columnNumber,
          gridRow: gridRowContainerStyling,
        }}
      />
      <For each='Component' of={components} index='i'>
        <Choose>
          <When condition={i === 0}>
            {/* eslint-disable react/jsx-no-undef */}
            <Component key={i} row={i + 1} elementMargin={{ mt: innerElementMargin, mb: 'sm' }} />
          </When>
          <When condition={i + 1 === components.length}>
            {/* eslint-disable react/jsx-no-undef */}
            <Component key={i} row={i + 1} />
          </When>
          <Otherwise>
            {/* eslint-disable react/jsx-no-undef */}
            <Component key={i} row={i + 1} elementMargin={{ mb: innerElementMargin }} />
          </Otherwise>
        </Choose>
      </For>
    </div>
  )
}
export default CardWithStep
